import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApplicationService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getApplications(payload) {
		return this._http.get(this.baseUrl + '/admin/applications/', { params: payload.params });
	}
	addApplication(payload) {
		return this._http.post(`${this.baseUrl}/admin/applications/`, payload.body);
	}
	editApplication(payload) {
		return this._http.put(`${this.baseUrl}/admin/applications/${payload.applicationId}/`, payload.body);
	}
	makeAppPublic(payload) {
		return this._http.put(
			`${this.baseUrl}/admin/applications/${payload.applicationId}/public/?status=${payload.status}`,
			payload.body
		);
	}

	uploadAppLogo(payload) {
		return this._http.post(
			`${this.baseUrl}/admin/applications/${payload.applicationId}/logo_base64/`,
			payload.body
		);
	}

	removeApp(payload) {
		return this._http.delete(`${this.baseUrl}/admin/applications/${payload.applicationId}/`);
	}
}
